import { homeRoutes } from "@/util/constant/RouteConstant.ts";
import { FaTwitter } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa";
import { svgLinks } from "../../../../public/assets/assetLinks";
import { PiInstagramLogoFill } from "react-icons/pi";
import { useNavigate } from "react-router-dom";

export const Footer = () => {
  const navigate = useNavigate();
  return (
    <div className="mt-20  items-center  flex flex-col w-full">
      <div className="bg-[#14151A] py-5 w-full items-start px-5 lg:space-y-0 space-y-5   lg:items-center justify-between flex-col lg:flex-row  flex">
        <img src={svgLinks.logo} />
        <div className=" flex flex-col md:flex-row  lg:flex-row  text-lg gap-5 lg:gap-10">
          {homeRoutes.navRoutes.map((route, index) => (
            <span
              key={index}
              onClick={() => navigate(route.path)}
              className="cursor-pointer text-[#FFFFFF99]"
            >
              {route.name}
            </span>
          ))}
        </div>
        <div className=" flex flex-row  text-lg gap-5">
          <FaTwitter color="#F5A58E" />
          <PiInstagramLogoFill color="#F5A58E" />
          <FaFacebook className="text-[#F5A58E]" />
        </div>
      </div>
      <h1 className="py-5 text-[#FFFFFF75]">
        Qoonity. All rights reserved. © {new Date().getFullYear()}
      </h1>
    </div>
  );
};
